// extracted by mini-css-extract-plugin
module.exports = {"gallery":"cafeteria_gallery__bwiMS","menu":"cafeteria_menu__2LmlX"};